import { defineComponent as _defineComponent } from 'vue'
import BCXValidatedInput from '@/components/molecules/BCXValidatedInput.vue';
import { reactive } from 'vue';
import useBCValidators from '@/mixins/useBCValidators';
import useVuelidate from '@vuelidate/core';
import ActionButtons from '@/views/settings/components/utils/ActionButtons.vue';
import BackendErrors from '@/components/login-register/BackendErrors.vue';
import useUpdateTools from '@/views/settings/utils/useUpdateTools';
import { Settings, SettingsVerificationType } from '@/models/Settings';
import { setCompanyName } from '@/services/Settings/Api';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySetting',
  setup(__props) {

const fields = reactive({
  companyName: '',
});

const { required } = useBCValidators();

const rules = {
  companyName: { required },
};

const v = useVuelidate(rules, fields);

const setBySettings = (settings: Settings | null) => {
  const userData = settings?.userDataSettings;
  fields.companyName = userData?.companyName;
};

const fnSave = () => setCompanyName(fields);

const {
  isLoading,
  save,
  reset,
  backendErrors,
  isDirty,
} = useUpdateTools(v, fnSave, setBySettings, SettingsVerificationType.CompanyName);

return { __sfc: true,fields, required, rules, v, setBySettings, fnSave, isLoading, save, reset, backendErrors, isDirty, BCXValidatedInput, ActionButtons, BackendErrors }
}

})